// attachmentIcons.js mapea la extensión de un Adjunto de Terreno al nombre
// de ícono de FontAwesome ya registrado en main.js — usado tanto por
// AttachmentGallery.vue (tarjetas/lightbox) como por TerrainResponsesTable.vue
// (celda compacta), para que ambos muestren el mismo ícono por tipo.
const ICONS_BY_EXTENSION = {
  '.pdf': 'file-pdf',
  '.docx': 'file-word',
  '.xlsx': 'file-excel',
  '.csv': 'file-csv',
  '.jpg': 'image',
  '.jpeg': 'image',
  '.png': 'image',
  '.webp': 'image',
};

export function extensionOf(name) {
  const match = /\.[a-z0-9]+$/i.exec(name || '');
  return match ? match[0].toLowerCase() : '';
}

export function iconForAttachmentName(name) {
  return ICONS_BY_EXTENSION[extensionOf(name)] || 'file-alt';
}
